/**
 * @fileoverview Entity Picker entity type list presentation component
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.EntityTypeList');

import {getEntityIcon} from '/ui/components/entitypicker/itemlist/entityicon';
import {EntityTypeHeader} from '/ui/components/entitypicker/itemlist/entitytypeheader';
import {yext} from '/ui/lib/msg';


export class EntityTypeList extends React.Component {
  constructor(props) {
    super(props);

    this.noResultsMsg = yext.msg('There were no entity types found');
  }

  render() {
    return (
      // NOTE(amullings): This class has no CSS associated with it, causing the
      // padding on the no-results span to be ignored. <span>s aren't permitted
      // content inside list elements anyway, so the better way to fix this
      // would be to simply display the <span> without the <ul>. This applies to
      // the folder and label lists as well.
      <ul className="uep-entity-type-list">
        {this.props.types.length > 0
          ? this.props.types.map(type => (
            <div className="uep-entity-type" key={type.id}>
              <EntityTypeHeader
                type={type}
                icon={getEntityIcon(type)}
                onClick={() => this.props.entityTypeClickHandler(type)}
                usingEntities={false}
              />
            </div>
          ))
          : <span className="uep-no-results">{this.noResultsMsg}</span>}
      </ul>
    );
  }
}
